import moment from 'moment';
import {momentWrapper} from 'components/Inputs/Dates/utils/momentWrapper';

import getTr from 'translation';

export const nextMonth = (date) => {
  const passYear = date.getMonth() === 11;
  const newMonth = passYear ? 0 : date.getMonth() + 1;
  const year = passYear ? date.getFullYear() + 1 : date.getFullYear();
  return new Date(year, newMonth, 1);
};

export const prevMonth = (date) => {
  const passYear = date.getMonth() === 0;
  const newMonth = passYear ? 11 : date.getMonth() - 1;
  const year = passYear ? date.getFullYear() - 1 : date.getFullYear();
  return new Date(year, newMonth, 1);
};

export const isDayEqual = (date_1, date_2) =>

/*
 * date_1: Moment or Date
 * date_2: Moment or Date
 */
  date_1 && date_2 &&
      new Date(date_1).setHours(0, 0, 0, 0) ===
      new Date(date_2).setHours(0, 0, 0, 0);

export const isDayBefore = (date_1, date_2) =>

/*
 * date_1: Moment or Date
 * date_2: Moment or Date
 */
  date_1 && date_2 &&
      new Date(date_1).setHours(0, 0, 0, 0) <
      new Date(date_2).setHours(0, 0, 0, 0);

export const isDayBeforeOrEqual = (date_1, date_2) => isDayBefore(date_1, date_2) || isDayEqual(date_1, date_2);

export const isDayAfter = (date_1, date_2) =>

/*
 * date_1: Moment or Date
 * date_2: Moment or Date
 */
  date_1 && date_2 &&
      new Date(date_1).setHours(0, 0, 0, 0) >
      new Date(date_2).setHours(0, 0, 0, 0);

export const isDayAfterOrEqual = (date_1, date_2) => isDayAfter(date_1, date_2) || isDayEqual(date_1, date_2);

export const relativeDateMap = {
  now: () => moment()
};

function _deserializeFunctionPart (part) {
  const relativeDate = relativeDateMap[part];
  if (relativeDate) {
    return relativeDate(part);
  }

  // TODO: remove unary plus deleting after update moment.js to 2.8.0 version
  if (part.startsWith('+')) {
    part = part.substring(1);
  }

  return moment.duration(part);
}

function _buildData (functionParts) {
  const firstPart = _deserializeFunctionPart(functionParts.shift());
  return functionParts.
    map(part => _deserializeFunctionPart(part)).
    reduce((total, part) => moment(total + part), firstPart);
}

function _prepareFormula (formula) {
  return formula.replace(/\s+/g, '');
}

function _tokenizeFormula (formula) {
  formula = _prepareFormula(formula);

  const operators = ['-', '+'];
  const operatorsRegex = new RegExp(`[${operators.join('')}]`, 'g');
  const formulaParts = [];

  let match;
  let prevOpIdx = 0;
  do {
    match = operatorsRegex.exec(formula);
    const opIdx = match && match.index;

    if (opIdx > 0) {
      formulaParts.push(formula.substring(prevOpIdx, opIdx));
    } else if (opIdx === -1 || !match) {
      break;
    }

    prevOpIdx = opIdx;
  } while (match);

  formulaParts.push(formula.substring(prevOpIdx));

  return formulaParts;
}

export function dateIsRelative (date) {
  return typeof date === 'string' && _.any(Object.keys(relativeDateMap), key => date.includes(key));
}

/**
 * data must be Moment object
 */
function _checkFormula (formula) {
  if (typeof formula !== 'string') {
    throw new Error('formula must be string');
  }
  if (!dateIsRelative(formula)) {
    throw new Error('formula must contains at least one relative date');
  }
}

/**
 * formula can contain arithmetical operators, durations and relative dates
 * it must not contain only durations
 * @param formula {String}
 * @return {?Date}
 */
export function parseRelativeDateFormula (formula) {
  _checkFormula(formula);
  const formulaParts = _tokenizeFormula(formula);
  const data = _buildData(formulaParts);
  return data.toDate();
}

export function serializeRelativeDate (date) {
  let durationString = moment.duration(moment(date) - moment()).toISOString();

  if (!durationString.startsWith('-')) {
    durationString = `+${durationString}`;
  }

  return `now${durationString}`;
}

export const dateRangeTranslations = () => ({
  'All time': () => getTr('all_time'),
  Yesterday: () => getTr('yesterday'),
  'This week': () => getTr('this_week'),
  'Last week': () => getTr('last_week'),
  'This month': () => getTr('this_month'),
  'Last month': () => getTr('last_month')
});

export const dateIsBetween = (target, minDate, maxDate) => {
  const targetMoment = moment(target);
  return moment(minDate) < targetMoment && targetMoment < moment(maxDate);
};

export const getDateOrNull = (date) => {
  if (!date) {
    return null;
  }
  return moment(date).toDate();
};

export const getUnixTimestamp = (date) => moment(date).valueOf();

export function parseDate (date) {
  if (!date) {
    return null;
  }
  if (moment(date).isValid()) {
    return moment(date).toDate();
  }
  if (typeof date === 'string') {
    try {
      return parseRelativeDateFormula(date);
    } catch (e) {
      return null;
    }
  }
  return null;
}

export function toUtcString (date) {
  date = parseDate(date);
  return date && momentWrapper(date).formatDateApi();
}

export const relativeDateConverters = {
  in: parseDate,
  out (i) {
    if (!i) {
      return null;
    }
    if (typeof i === 'string') {
      return i;
    }
    return momentWrapper(i).formatDateApi();
  }
};
